import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function validateUrl(url) {
  if (!url) return false;

  try {
    // Add https:// if no protocol is specified
    const urlToTest = url.match(/^https?:\/\//) ? url : `https://${url}`;
    new URL(urlToTest);
    return true;
  } catch (e) {
    return false;
  }
}

export function formatUrl(url) {
  if (!url) return "";

  // Remove any existing http:// or https:// to avoid duplicates
  let cleanUrl = url
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//i, "");

  // Add https:// if not present
  if (cleanUrl) {
    cleanUrl = "https://" + cleanUrl;
  }

  return cleanUrl;
}
